import React, { useEffect, useState } from 'react';
import {
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from '@material-ui/core';
import { useSelector } from 'react-redux';
import { Camera, Select } from '../../components';
import useOverviewEffects from './hooks';
import './overview.css';
import CircularLoader from '../../components/Loaders/CircularLoader';
import { settingsSelector } from '../../store/reducers/settings';
import NoCameraImg from '../../static/images/disabled-camera.png';

const Overview = () => {
  const {
    image,
    predictionDetails,
    predictionsList,
    host,
    port,
    configOptions,
    currentConfig,
    loading,
    classes,
    properties,
    onConfigChange,
    onCapture,
    showCrosshair,
    setShowCrosshairWrapper,
    handleEnableVideo,
    enableVideoBtnClicked,
    handleRestartAgent,
    runPrediction,
    setRunPredictionWrapper,
  } = useOverviewEffects();

  const settings = useSelector(settingsSelector);

  const videoStreamEnabled = settings?.VideoStream?.enabled ?? false;

  const [videoDisabled, setVideoDisabled] = useState(undefined);

  const predictionError = useSelector((state) =>
    [
      state?.predictions?.error,
      ...(state?.predictions?.predictions ?? []).map((p) => p?.error),
    ].filter(Boolean)
  );

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (
        (videoStreamEnabled === undefined && !image) ||
        (videoStreamEnabled === false && !image)
      ) {
        setVideoDisabled(true);
      } else {
        setVideoDisabled(false);
      }
    }, 3000);
    return () => clearTimeout(timeout);
  }, [videoStreamEnabled, image]);

  const showAgentTable = () => {
    return (
      <div>
        <TableContainer component={Paper} className={classes.tableContainer}>
          <Table aria-label="simple table">
            <TableBody>
              {properties.map((row) => (
                <TableRow key={row.property}>
                  <TableCell
                    component="th"
                    scope="row"
                    className={classes.tablePropertyCell}
                  >
                    {row.property}:
                  </TableCell>
                  <TableCell align="left">{row.value}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <div className="overview__restart-agent__btn--container">
          <button
            className="overview__restart-agent__btn--btn"
            type="submit"
            onClick={handleRestartAgent}
          >
            Restart Agent
          </button>
        </div>
      </div>
    );
  };

  const showCamera = (cameraOn = true) => {
    if (cameraOn && !image) {
      return <CircularLoader width="5em" height="5em" />;
    }
    return (
      <Grid container spacing={3}>
        <Grid item xs={6}>
          {/* eslint-disable-next-line no-nested-ternary */}
          <Camera
            image={image}
            componentImg={cameraOn ? null : NoCameraImg}
            predictionDetails={predictionDetails}
            predictionsList={predictionsList}
            host={host}
            port={port}
            onCapture={onCapture}
            xs={11}
            height={30}
            disabled={loading}
            showCrosshair={showCrosshair}
            setShowCrosshair={setShowCrosshairWrapper}
            runPrediction={runPrediction}
            setRunPrediction={setRunPredictionWrapper}
          />
          <Select
            options={configOptions}
            currentOptionIndex={currentConfig}
            onSelect={onConfigChange}
            label="Config"
            className={classes.select}
          />
        </Grid>
        <Grid item xs={5}>
          {showAgentTable()}
        </Grid>
      </Grid>
    );
  };

  const showActivateVideo = () => {
    return (
      <div className="overview__enable-video__container">
        <div className="overview__enable-video__img-container">
          <p className="overview__enable-video__text">Video is Disabled</p>
          {enableVideoBtnClicked ? (
            <div className="overview__enable-video__loader">
              <CircularLoader width="2em" height="2em" />
            </div>
          ) : (
            <button
              className={classes.button}
              type="submit"
              onClick={handleEnableVideo}
            >
              Enable Video
            </button>
          )}
        </div>
        <div style={{ width: '100%' }}>{showAgentTable()}</div>
      </div>
    );
  };

  const conditionalRender = () => {
    if (predictionError && predictionError.length > 0) {
      return showCamera(false);
    }
    if (videoDisabled) {
      return showActivateVideo();
    }
    if (videoStreamEnabled === undefined || videoStreamEnabled === null) {
      return <CircularLoader width="5em" height="5em" />;
    }
    return showCamera();
  };

  return conditionalRender();
};

export default Overview;
